import React, { useState } from 'react';
import Menu from './Menu';
import Categories from './Categories';
import items from './data';

// dynamically get categories from data
const allCategories = ['all', ...new Set(items.map((item) => item.category))];
console.log(allCategories);

function App() {
  const [menuItems, setMenuItems] = useState(items);
  const [categories, setCategories] = useState(allCategories);

  const filterItems = (category) => {
    const newItem = items.filter((item) => item.category === category);
    if (category === 'all') {
      return setMenuItems(items);
    }
    setMenuItems(newItem);
  };

  return (
    <main>
      <section className="menu section">
        <div className="title">
          <h2>Menu</h2>
          <div className="underline"></div>
        </div>
        <Categories categories={categories} filterItems={filterItems} />
        <Menu items={menuItems} />
      </section>
    </main>
  );
}

export default App;
